var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 40,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("span", [_vm._v("Download Options")]),
              ]
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("p", [
                _vm._v(
                  "AudaNet will overwrite quote. Are you sure you want to continue?"
                ),
              ]),
              _c("br"),
              _c("p", [
                _c("strong", [_vm._v("Download")]),
                _vm._v(" - Will NOT overwrite if calculation ID is the same"),
              ]),
              _c("p", [
                _c("strong", [_vm._v("Download & Overwrite")]),
                _vm._v(" - Will overwrite even if calculation ID is the same"),
              ]),
              _c("p", [
                _c("strong", [_vm._v("Cancel")]),
                _vm._v(" - Cancel download quote operation"),
              ]),
            ]),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Download" },
                  on: {
                    click: function ($event) {
                      return _vm.download()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-download" }),
                  ]),
                  _c("span", [_vm._v("Download")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Download & Overwrite" },
                  on: {
                    click: function ($event) {
                      return _vm.overwrite()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-download" }),
                  ]),
                  _c("span", [_vm._v("Download & Overwrite")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: {
                    "data-tooltip": "Cancel",
                    disabled: _vm.cancelDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("span", [_vm._v("Cancel")])]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }